/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkConnectionAccess} from '../api'

export const useMutationCheckConnectionAccess = createReactQueryMutationHook('checkConnectionAccess', checkConnectionAccess)
